{
  "title": "System Backdoor (UA)",
  "source": "Unearthed Arcana 7 - Modern Magic",
  "levelAndSchool": "4th-level transmutation (technomagic)",
  "level": 4,
  "castingTime": "1 minute",
  "range": "Self",
  "components": "V, S, M (hacking tools)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "This spell allows you to bypass system security in order to create a secure login on a foreign system. The login you create allows you administrator-level privileges in any computer system not enhanced through technomagic. The login defeats any technomagic spells of 3rd level or lower.",
    "Once the duration of the spell expires, the login and all privileges are wiped from the system. System logs still show the activity of the user, but the user identification cannot be found or traced.",
    "At Higher Levels. When you cast this spell using a spell slot of 5th level or higher, you are able to bypass technomagic spells if the spell’s level is equal to or less than the level of the spell slot you used."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
